<template>
  <div class="home-container">
    <van-skeleton :row="6" :loading="loading">
      <div class="banner-wrap">
        <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
          <van-swipe-item v-for="(item, index) in bannerUrls" :key="index">
            <van-image :src="item" fit="fill" />
          </van-swipe-item>
        </van-swipe>
      </div>
    </van-skeleton>
    <div class="bg-container">
      <!-- 中秋专区 -->
      <van-skeleton :row="3" :loading="loading">
        <div class="mid-section-wrap">
          <div class="mid-section">
            <van-image :src="midAutumnPicUrl" style="width: 100%; height: 100%" fit="contain" @click="goClassify"></van-image>
          </div>
        </div>
      </van-skeleton>

      <!-- 套餐专区 -->
      <van-skeleton :row="8" :loading="loading">
        <div class="combo-section-container">
          <div class="combo-section-wrap">
            <div class="combo-title">
              <!-- <span>请选择套餐</span> -->
              <van-image :src="require('@/assets/images/home_text_title.png')"></van-image>
            </div>
            <div class="combo-section-item-wrap">
              <div class="combo-section-item" v-for="item in productCategoryList" :key="item.id" @click="goDetals(item.id)">
                <van-image :src="item.picUrl" fit="contain" style="width: 100%; height: 100%"></van-image>
                <!-- <span class="item-text">{{ item.category }}</span> -->
              </div>
            </div>
          </div>
        </div>
      </van-skeleton>

      <!-- 客服服务 -->
      <van-skeleton :row="3" :loading="loading">
        <!-- <div class="service">
          <span @click="goService">点击进入客服服务</span>
        </div> -->
        <div class="service">
          <div class="btn" @click="goService">
            <van-icon name="service-o" style="margin-right: 5px" />
            <span>在线客服</span>
          </div>
          <div class="service-time">客服时间: 09:00 - 21:00</div>
        </div>
      </van-skeleton>
      <!-- 二维码弹窗 -->
    <!-- <div v-if="NoticeImg" class="modal" @click="showNoticeFn">
      <div class="modal-content" @click.stop>
        <div class="modal-header">
          <h3>公告</h3>
          <button class="close-btn" @click="showNoticeFn">&times;</button>
        </div>
        <div class="modal-body">
          <img src="../../assets/images/guoqing.png" alt="" class="qrcode" />
        </div>
      </div>
    </div> -->
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant'
import { AddShoppingCartApi } from '@/api/cart.js'
import { getIndexDetailApi, getIndexCategoryListApi, getIndexProductPackageListApi, getIndexProductListApi } from '@/api/home.js'
import Cookies from 'js-cookie'
import { mapGetters } from 'vuex';
export default {
  name: 'Home',
  data() {
    return {
      bannerUrls: '',
      midAutumnPicUrl: '',
      productCategoryList: [],
      loading: true,
      // showQRCode: true
      // Notice: true
    }
  },
  computed: {
    ...mapGetters(['NoticeImg'])
  },
  created() {
    // console.log(this.$store.getters.Notice,'Notice');
    console.log(this.$store.state,'setting');
    console.log(this.$store,'setting');
    
    this.$store.commit('user/SET_ACTIVE', 0)
    this.getIndexDetailFn()
  },
  methods: {
    showNoticeFn() {
      this.$store.commit('settings/SET_NOTICE', false)
      // this.Notice = false
      // Cookies.set('Notice', this.Notice)
    },
    async getIndexDetailFn() {
      const res = await getIndexDetailApi()
      this.bannerUrls = res.data.bannerUrls
      this.midAutumnPicUrl = res.data.midAutumnPicUrl
      this.productCategoryList = res.data.productCategoryList
      this.loading = false
    },
    goService() {
      this.$router.push('/service')
    },
    goDetals(id) {
      this.$router.push({
        path: '/classify',
        query: {
          id
        }
      })
    },
    goClassify() {
      this.$router.push('/classify')
    }
  }
}
</script>

<style>
 .modal {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.7);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
  }
  .modal-content {
    background: white;
    border-radius: 12px;
    width: 90%;
    overflow: hidden;
    animation: modalShow 0.3s ease;
  }
  @keyframes modalShow {
    from {
      transform: scale(0.9);
      opacity: 0;
    }
    to {
      transform: scale(1);
      opacity: 1;
    }
  }
  .modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px 20px;
    border-bottom: 1px solid #eee;
  }
  .modal-header h3 {
    /* // font-size: 18px; */
    font-size: 36px;
    color: #333;
  }
  .close-btn {
    background: none;
    border: none;
    /* // font-size: 24px; */
    font-size: 48px;
    cursor: pointer;
    color: #999;
  }
  .modal-body {
    padding: 25px 20px;
    text-align: center;
  }
  .qrcode {
    width: 100%;
    /* max-width: 350px; */
    margin-bottom: 15px;
    border: 1px solid #eee;
  }
  .modal-body p {
    color: #666;
    font-size: 28px;
  }
.home-container {
  
  .banner-wrap {
    width: 100%;
    aspect-ratio: 1/0.6;
    overflow: hidden;

    .my-swipe .van-swipe-item {
      color: #fff;
      font-size: 20px;
      width: 100%;
      height: 600px;
      /* aspect-ratio: 1/0.6; */
      text-align: center;
      background-color: #39a9ed;

      .van-image {
        width: 100%;
        height: 100%;
      }
    }
  }

  .bg-container {
    width: 100%;
    min-height: calc(100vh - 100px - 600px);
    /* background: linear-gradient(184deg, #FEEBC2 0%, #FFB699 100%); */
  }

  .mid-section-wrap {
    padding: 0 50px;
    /* margin-top: 40px; */
    padding-top: 40px;
    .mid-section {
      width: 100%;
      /* height: 180px; */
      border-radius: 90px;
      /* background-color: black; */
    }
  }

  .combo-section-container {
    width: 100%;
    padding: 0 40px;
    box-sizing: border-box;
    margin-top: 32px;

    .combo-section-wrap {
      padding: 20px;
      padding-bottom: 0;
      box-sizing: border-box;
      /* margin-top: 40px; */
      width: 100%;
      display: flex;
      /* justify-content: space-between; */
      align-items: center;
      flex-direction: column;
      /* flex-wrap: wrap; */
      /* background: linear-gradient( 184deg, #FEEBC2 0%, #FFB699 100%); */
      /* background: linear-gradient(#ffdecf 0%, #fef7e0 100%); */
      border-radius: 40px;

      .combo-title {
        font-family: Source Han Sans SC, Source Han Sans SC;
        font-weight: 700;
        font-size: 40px;
        letter-spacing: 8px;
        color: #901d22;
        line-height: 52px;
        text-shadow: 0px 2px 3px rgba(241, 162, 68, 0.25);
        text-align: center;
      }

      .combo-section-item-wrap {
        width: 100%;
        margin-top: 40px;
        display: flex;
        justify-content: space-between;
        /* justify-content: flex-start; */
        flex-wrap: wrap;
        .combo-section-item {
          width: calc((100% - 60px) / 3);
          aspect-ratio: 1 / 1;
          border-radius: 20px;
          margin-bottom: 40px;
          background: linear-gradient(321deg, #fde0ab 0%, rgba(253, 224, 171, 0) 100%);
          box-shadow: 0px 2px 4px 0px rgba(185, 69, 37, 0.25);
          display: flex;
          justify-content: center;
          align-items: center;
          .item-text {
            font-family: Source Han Sans SC, Source Han Sans SC;
            font-weight: 700;
            font-size: 45px;
            color: #901d22;
            line-height: 58px;
            letter-spacing: 1px;
            text-shadow: 0px 2px 3px rgba(241, 162, 68, 0.25);
            text-align: center;
            font-style: normal;
            text-transform: none;
          }
          
        }
        /* .combo-section-item:nth-child(3n) {
          &::after {
            flex: 1;
          }
        } */
        /* .combo-section-item:hover {
          background: linear-gradient(321deg, #901d22 0%, #ffa024 100%);
          .item-text {
            color: #fff;
          }
        } */
         &::after {
            content: '';
            width: calc((100% - 60px) / 3);
            /* aspect-ratio: 1 / 1; */
          }
      }
    }
  }

  .service {
    /* text-align: center; */
    font-size: 36px;
    /* color: #901d22; */
    /* font-weight: bolder; */
    margin-top: 40px;
    padding-bottom: 50px;
    /* text-decoration: underline; */
    /* border: 1px solid #222; */
    /* text-shadow: 0px 2px 3px rgba(241, 162, 68, 0.25); */
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    .btn {
      border: 1px solid #222;
      padding: 20px 30px;
      border-radius: 50px;
      font-size: 32px;
    }
    .service-time {
      font-size: 28px;
      margin-top: 20px;
      color: #666;
    }
  }
  
}
</style>
